import {
  graphql,
  PreloadedQuery,
  usePreloadedQuery,
  useQueryLoader,
  useSafeRelay,
} from 'utils/graphClient';
import { searchInfoQuery } from './__generated__/searchInfoQuery.graphql';

export type SearcInfoReference = PreloadedQuery<searchInfoQuery>;

const SearchInfoQuery = graphql`
  query searchInfoQuery {
    sessionInfo {
      member {
        spaceMemberships {
          nodes {
            space {
              id
              ...SpaceIndicator_space
            }
          }
        }
      }
    }
  }
`;

export const useSearchInfoQueryLoader = () => {
  return useQueryLoader<searchInfoQuery>(SearchInfoQuery);
};

export const usePreloadedSearchInfoQuery = (ref: SearcInfoReference) => {
  return usePreloadedQuery<searchInfoQuery>(SearchInfoQuery, ref);
};

export const useLazyLoadSearchInfoQuery = () => {
  const { useLazyLoadQuery } = useSafeRelay();

  return useLazyLoadQuery<searchInfoQuery>(SearchInfoQuery, {});
};
